'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notifyByPush = exports.notifyByTab = exports.notifyBySound = undefined;

var _emptyFunction = require('react-utils/emptyFunction');

var _emptyFunction2 = _interopRequireDefault(_emptyFunction);

var _NotificationFactory = require('conversations-core/notifications/NotificationFactory');

var _NotificationFactory2 = _interopRequireDefault(_NotificationFactory);

var _getStaticAssetUrl = require('conversations-lib/urls/getStaticAssetUrl');

var _getStaticAssetUrl2 = _interopRequireDefault(_getStaticAssetUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SOUND_URL = (0, _getStaticAssetUrl2.default)('conversations-core/static-1.139/audio/notification.mp3');

var notifyBySound = exports.notifyBySound = function notifyBySoundIife() {
  if (typeof window.Audio !== 'function') {
    return _emptyFunction2.default;
  }

  var MAX_SOUND_REPEATS = 2;
  var notificationSound = new window.Audio(SOUND_URL);
  var soundInterval = null;
  var focusEvent = null;

  var canPlay = true;
  var playPromise = null;

  var playSafely = function playSafely() {
    if (canPlay) {
      canPlay = false;
      playPromise = notificationSound.play();
      if (playPromise !== undefined) {
        playPromise.then(function () {
          canPlay = true;
        }).catch(function () {
          // notification prevented
          canPlay = true;
        });
      } else {
        canPlay = true;
      }
    }
  };

  return function (isAdmin) {
    playSafely();

    if (isAdmin) {
      var numRepeats = 0;

      // clear existing interval and listener
      clearInterval(soundInterval);
      window.removeEventListener('focus', focusEvent);

      soundInterval = setInterval(function () {
        playSafely();

        // only repeat the sound 2 times maximum
        if (++numRepeats === MAX_SOUND_REPEATS) {
          clearInterval(soundInterval);
        }
      }, 30000);

      // clear the interval if a user focuss into the app
      focusEvent = window.addEventListener('focus', function () {
        clearInterval(soundInterval);
        window.removeEventListener('focus', focusEvent);
      });
    }
  };
}();

var notifyByTab = exports.notifyByTab = function notifyByTabIife() {
  var originalTitle = document.title;
  var unreadCount = 0;
  var focusEvent = null;

  return function () {
    document.title = '(' + ++unreadCount + ') ' + originalTitle;

    // clear existing event
    window.removeEventListener('focus', focusEvent);

    focusEvent = window.addEventListener('focus', function () {
      document.title = originalTitle;
      window.removeEventListener('focus', focusEvent);
      unreadCount = 0;
    });
  };
}();

function notificationClick(channel, switchToChannel) {
  window.focus();
  switchToChannel(channel);
}

var notifyByPush = exports.notifyByPush = function notifyByPushIife() {
  var notificationFactory = new _NotificationFactory2.default();
  return function (channel, visitor, message, switchToChannel) {
    var onClick = function onClick() {
      return notificationClick(channel, switchToChannel);
    };
    notificationFactory.buildNotificaiton(channel, visitor, message, onClick);
  };
}();


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/notifications/notifications.js
// module id = 492
// module chunks = 0